import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'LoginNotification' })({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        padding: '32px 20px 32px 20px',
        background: '#f9f6f3',
        position: 'sticky',
        bottom: 0
    },
    title: {
        color: '#232323',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: 600,
        lineHeight: '150%',
        margin: 0
    },
    hint: {
        color: '#8e8e8e',
        textAlign: 'center',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '150%',
        margin: 0
    },
    close: {
        position: 'absolute',
        right: 5,
        top: 5
    },
    oauthButtonGroup: {
        justifyContent: 'center'
    },
    link: {
        textDecoration: 'none'
    }
});
